/**
 * Converts seconds to time format (HH:MM:SS)
 * @param {number} seconds - The number of seconds to convert
 * @returns {string} Time in HH:MM:SS format
 */
export const secondsToTime = (seconds) => {
	const h = Math.floor(seconds / 3600);
	const m = Math.floor((seconds % 3600) / 60);
	const s = Math.floor(seconds % 60);
	return [h, m, s].map(v => String(v).padStart(2, '0')).join(':');
};

/**
 * Converts time string (HH:MM:SS) to seconds
 * @param {string} str - Time string in HH:MM:SS format
 * @returns {number} Total seconds or NaN if invalid
 */
export const timeToSeconds = (str = '') => {
	const [h = '0', m = '0', s = '0'] = str.split(':');
	const hh = Number(h), mm = Number(m), ss = Number(s);
	if (Number.isNaN(hh) || Number.isNaN(mm) || Number.isNaN(ss) || hh < 0 || mm < 0 || ss < 0 || mm > 59 || ss > 59)
		return NaN;
	return hh * 3600 + mm * 60 + ss;
};

/**
 * Get maximum time in HH:MM:SS format based on video duration
 * @param {number} videoDuration - Video duration in seconds
 * @returns {string} Maximum time in HH:MM:SS format
 */
export const getMaxTime = (videoDuration) => {
	if (!videoDuration) return '23:59:59';
	const max = Math.floor(videoDuration);
	const maxHours = Math.floor(max / 3600);
	const maxMinutes = Math.floor((max % 3600) / 60);
	const maxSeconds = max % 60;
	return [maxHours, maxMinutes, maxSeconds].map(v => String(v).padStart(2, '0')).join(':');
};
